import { calculateHaversineDistanceKm } from "@utils/maps/mapGeometry";

export function buildMeasurementGeoJson(rawPoints = []) {
  const normalizedPoints = (Array.isArray(rawPoints) ? rawPoints : [])
    .map((point) => [Number(point?.longitude), Number(point?.latitude)])
    .filter(
      ([longitude, latitude]) =>
        Number.isFinite(longitude) && Number.isFinite(latitude),
    )
    .slice(0, 2);
  const features = normalizedPoints.map((coordinates, index) => ({
    type: "Feature",
    properties: { featureType: "point", pointLabel: index === 0 ? "A" : "B" },
    geometry: { type: "Point", coordinates },
  }));

  if (normalizedPoints.length === 2) {
    const distanceKm = calculateHaversineDistanceKm(
      { longitude: normalizedPoints[0][0], latitude: normalizedPoints[0][1] },
      { longitude: normalizedPoints[1][0], latitude: normalizedPoints[1][1] },
    );
    const distanceLabel =
      distanceKm < 1
        ? `${Math.round(distanceKm * 1000)} m`
        : `${distanceKm.toFixed(distanceKm >= 10 ? 2 : 3)} km`;
    features.unshift({
      type: "Feature",
      properties: { featureType: "line" },
      geometry: { type: "LineString", coordinates: normalizedPoints },
    });
    features.push({
      type: "Feature",
      properties: { featureType: "label", distanceLabel },
      geometry: {
        type: "Point",
        coordinates: [
          (normalizedPoints[0][0] + normalizedPoints[1][0]) / 2,
          (normalizedPoints[0][1] + normalizedPoints[1][1]) / 2,
        ],
      },
    });
  }
  return { type: "FeatureCollection", features };
}
